module.exports = __webpack_public_path__ + "assets/img/left_1.3c284323.png";